import { ProfileVerificationStatus } from './ProfileVerificationStatus';
import { EmployeeFinanceDetails } from './EmployeeFinanceDetails';

export class HrEmployeeFinanceDetails {
  EmpCode: number;
  UAN: string;
  OptedNationalPensionScheme: boolean;
  NpsPran: string;
  BankName: string;
  BankAccount: string;
  BankAccountName: string;
  IFSCCode: string;
  Branch: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  CancelledChequeFilePath: string;
  CancelledChequeFileName: string;
  PF_StartDate: Date;
  IsMigratedOnH1: boolean;
  IsEligibleForPF: boolean;
  Billability: boolean;
  CostCenter: string;
  SSN: string;
  Elig_Med: number;
  Elig_InC: number;
  Elig_NnP: number;
  empFinanceDetails: EmployeeFinanceDetails[];
  profileVerification:  ProfileVerificationStatus = new ProfileVerificationStatus();
  NoOfAccounts: number;
  isFromProfile: boolean;
}
